// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2bG06","legacyBtn":"MutateMid_legacyBtn__3V2li"};